import { classnames } from '@carvana/merch-search/utilities';
import { hasCleanTaxCredit } from '@/SearchResults/ResultTileV2/helpers/ResultTile.helpers';
import { useTileDataContext } from '~/contexts/TileDataContext';
import EvCreditPill from './EvCreditPill';

const Pills = () => {
  const { tileData } = useTileDataContext();
  const showEvPill = hasCleanTaxCredit(tileData);

  return (
    <div
      className={classnames(
        showEvPill ? 'flex' : 'hidden',
        'absolute bottom-[-200px] right-[16px] pointer-events-auto'
      )}
    >
      <EvCreditPill />
    </div>
  );
};

export default Pills;
